import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiProviderService } from './api-provider.service';
import { User } from '../micro-services/user/models/user';
import { UserCoach } from '../micro-services/user/models/user-coach';
import { UserFactory } from '../micro-services/user/user-factory';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  public selectedClient : User;
  public user: User;
  private roles: Array<string> = [];

  constructor(public apiProvider : ApiProviderService, private userFactory : UserFactory) { }

  public setUser<T extends User>(user: T, roles: Array<string> = []): UserService{
    //this.user = this.userFactory.create(user);
    this.user = user;
    localStorage.setItem('user', JSON.stringify(this.user));
    this.setUserRole(roles);
    return this;
  }

  public getUser(): User{
    
    let user = JSON.parse(localStorage.getItem('user'));
    this.user = this.userFactory.create(user);
    return this.user;
  }

    /**
   * getUsers
   */
public getUsers():Observable<User[]> {
  return this.apiProvider.getUsers()
 }

  public fillObject<T,U extends T>(obj1: T, obj2: U)
  {
    Object.keys(obj2).forEach(
      (key) => {
        if(obj1[key] !== undefined){
          obj1[key]=obj2[key];
        }
      }
    );
    return obj1;
  }

  public fillObjects<T,U extends T>(obj1: T, obj2: U)
  {
    Object.keys(obj2).forEach(
      (key) => {
        if(obj1[key] !== undefined){
          obj1[key]=obj2[key];
        }
      }
    );
    return obj1;
  }

  private setUserRole(roles: Array<string>){
    this.roles = roles;
    localStorage.setItem('userRole', JSON.stringify(this.roles));
    return this;
  }

  getUserRole(){
    this.roles = JSON.parse(localStorage.getItem('userRole'));
    return this.roles;
  }

}
